import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { provider } from '../../firebase';
import { UserContext } from '../../providers/UserProvider';

const Login = () => {
    const user = useContext(UserContext);

    const signInWithGoogle = async () => {
        const auth = getAuth();
        signInWithPopup(auth, provider)
            .then((result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                const resultUser = result.user;
                console.info('Auth ok');
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                const email = error.customData.email;
                const credential = GoogleAuthProvider.credentialFromError(error);
                console.error('Auth error: ', errorMessage);
            });
    };
    console.log('context user', user);
    return (
        <main className="relative mx-auto container max-w-lg">
            {user ? (
                <>
                    <h1 className="mt-40 mb-4 text-center uppercase tracking-wide text-2xl ml-4 text-purple-900 font-semibold">
                        {user ? `HOLA ${user?.email}` : 'LOGIN TO ADMIN'}
                    </h1>
                    <Link
                        to="/admin/create"
                        className="relative block text-center mx-auto mt-8 py-4 px-8 bg-green-500 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75">
                        Continuar
                    </Link>
                </>
            ) : (
                <>
                    <h1 className="mt-40 mb-4 text-center uppercase tracking-wide text-2xl ml-4 text-purple-900 font-semibold">
                        {user ? `HOLA ${user?.email}` : 'LOGIN TO ADMIN'}
                    </h1>
                    <div className="bg-white rounded-xl shadow-md overflow-hidden">
                        <div className="md:flex">
                            <div className="md:flex-shrink-0"></div>
                            <div className="w-full p-8 text-center">This is a private application, please login.</div>
                            <button
                                onClick={signInWithGoogle}
                                className="mx-auto py-4 px-8 bg-green-500 text-white font-semibold rounded-lg rounded-l-none shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75">
                                SIGN IN
                            </button>
                        </div>
                    </div>
                </>
            )}
        </main>
    );
};

export default Login;
